import Container from '@/components/atoms/Container'
import { useAppSelector } from '@/store/hooks'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.locale('pt-br')

export function Hero() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)
	const [greeting, setGreeting] = useState('')

	useEffect(() => {
		const arr = [
			[0, 4, 'Boa noite'],
			[5, 11, 'Bom dia'],
			[12, 17, 'Boa tarde'],
			[18, 24, 'Boa noite'],
		]

		const hr = new Date().getHours()

		const getGreeting = arr.find(
			(d) => hr >= Number(d[0]) && hr <= Number(d[1])
		)

		getGreeting
			? setGreeting(getGreeting[2]?.toString() as string)
			: setGreeting('Olá')
	}, [])

	return (
		<div className='flex w-full pt-10 pb-12'>
			<Container>
				<div className='flex flex-col gap-7 md:gap-14'>
					<div>
						<div className='flex gap-4 items-center'>
							<div className='flex flex-col gap-0 -mt-1 sm:mt-0'>
								<span className='text-zinc-50 font-medium leading-8'>
									{dayjs().locale('pt-br').format('DD [de] MMMM [de] YYYY')}
								</span>
								<p className='text-zinc-50 text-3xl lg:text-4xl leading-8 font-bold'>
									<span>{greeting},</span> {user?.name.split(' ')[0]}!
								</p>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</div>
	)
}
